// ViewMyListings.jsx
// Main component for viewing and managing user's listings

import React from 'react';
import ListingFilters from '../../components/ListingFilters';
import { styles } from './styles';
import useMyListings from './useMyListings';
import MyListingsHeader from './MyListingsHeader';
import MyListingsGrid from './MyListingsGrid';
import EmptyListingsState from './EmptyListingsState';
import LoadingState from './LoadingState';

const ViewMyListings = () => {
  const {
    listings,
    totalListings,
    loading,
    filters,
    setFilters,
    search,
    setSearch,
    sort,
    setSort,
    handleDelete,
    handleEdit,
    handleMarkSold,
    handleViewDetails,
    handleContactBuyer,
    handleArchive
  } = useMyListings();

  if (loading) {
    return <LoadingState />;
  }

  // Check if user has no listings at all
  const hasNoListings = totalListings === 0;
  
  // Check if filters are active and resulted in no matches
  const hasActiveFilters = filters.category || filters.minPrice || filters.maxPrice || search;
  const noFilteredResults = !hasNoListings && listings.length === 0 && hasActiveFilters;

  return (
    <div style={styles.pageContainer}>
      <div style={styles.contentWrapper}>
        <MyListingsHeader />
        
        {!hasNoListings && (
          <div style={styles.filtersSection}>
            <ListingFilters
              filters={filters}
              setFilters={setFilters}
              search={search}
              setSearch={setSearch}
              sort={sort}
              setSort={setSort}
              showSearch={true}
              showSort={true}
            />
          </div>
        )}

        <div style={styles.mainContent}>
          {hasNoListings ? (
            <EmptyListingsState />
          ) : noFilteredResults ? (
            <div style={styles.noResultsContainer}>
              <div style={styles.noResultsIcon}>🔍</div>
              <h3 style={styles.noResultsTitle}>No Listings Match Your Filters</h3>
              <p style={styles.noResultsText}>
                Try adjusting your search criteria or filters to find what you're looking for.
              </p>
              <button
                onClick={() => {
                  setFilters({ category: "", minPrice: "", maxPrice: "" });
                  setSearch("");
                }}
                style={styles.clearFiltersButton}
              >
                Clear All Filters
              </button>
            </div>
          ) : (
            <>
              <div style={styles.statsBar}>
                <span style={styles.statsText}>
                  {listings.length} {listings.length === 1 ? 'listing' : 'listings'} found
                </span>
              </div>
              <MyListingsGrid
                listings={listings}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onMarkSold={handleMarkSold}
                onViewDetails={handleViewDetails}
                onContactBuyer={handleContactBuyer}
                onArchive={handleArchive}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewMyListings;